import React, { Component } from "react"
import { connect } from "react-redux"
import { parse } from "query-string"
import { setToken } from "../util/jwt_utils"

import * as actionCreators from "../redux/action_creators"

class AcceptInvite extends Component {
    constructor(props) {
        super(props)
        const { t, i } = parse(props.location.search)
        this.state = {
            token: t,
            inviteId: i,
        }
    }

    componentWillMount() {
        const { inviteId, token } = this.state
        const { acceptTeamInvite, history } = this.props
        setToken(token)
        if (inviteId) {
            acceptTeamInvite(inviteId, history)
        }
    }

    render() {
        return (
            <div className="container">
                <div className="loading">
                    <p className="lead">Redirecting...</p>
                </div>
            </div>
        )
    }
}

export default connect(
    state => state,
    actionCreators,
)(AcceptInvite)



// WEBPACK FOOTER //
// ./src/pages/accept_invite.jsx